import { Paper, Typography } from '@mui/material';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const StatusPieChart = ({ data }) => (
  <Paper sx={{ p: 2.5, mb: 3 }}>
    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#0d3c61' }}>By Status</Typography>
    <ResponsiveContainer width="100%" height={350}>
      <PieChart>
        <Pie
          data={data}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          outerRadius={140}
          label={({ name, value }) => `${name}: ${value}`}
          labelLine
          fontSize={12}
        >
          {data.map((entry, i) => <Cell key={i} fill={entry.fill} />)}
        </Pie>
        <Tooltip />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  </Paper>
);

export default StatusPieChart;
